<template>
    <div class="root">
        <router-view></router-view>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({

});

</script>

<style lang="less" scoped>
.root {
    background-color: @bg_01;
    padding-top: 60px;
    padding-bottom: 120px;
    @media @mobile{
        padding: 0;
    }
}
</style>
